// FotoEinwilligung.jsx — Einwilligung zur Veröffentlichung von Fotos je Starter (V15, 18.10.2026)
//
// Steht im Anmeldefenster (Schritt Kategorien). Speichert jede Änderung
// sofort (PUT /api/fotos/:turnier/einwilligung); der Server lässt nur eigene
// Starter zu. Ohne Haken: keine Einwilligung, Fotos mit dieser Person
// erscheinen nicht in der öffentlichen Galerie.
// Bei Minderjährigen bestätigt der Verein die Einwilligung der
// Erziehungsberechtigten (eigener Text, gespeichert als art).
import React, { useEffect, useState } from 'react';
import './fotos.css';

const kopf = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export default function FotoEinwilligung({ turnierId, wettkaempferIds }) {
  const [d, setD] = useState(null);
  const [fehler, setFehler] = useState('');
  const [speichert, setSpeichert] = useState(null);
  const ids = [...new Set(wettkaempferIds || [])].sort((a, b) => a - b).join(',');

  useEffect(() => {
    if (!turnierId || !ids) { setD(null); return undefined; }
    let ab = false;
    (async () => {
      try {
        const r = await fetch(`/api/fotos/${turnierId}/einwilligung?ids=${ids}`, { headers: kopf() });
        const x = await r.json().catch(() => ({}));
        if (!r.ok || x.success === false) throw new Error(x.error || `HTTP ${r.status}`);
        if (!ab) { setD(x); setFehler(''); }
      } catch (e) { if (!ab) setFehler(e.message); }
    })();
    return () => { ab = true; };
  }, [turnierId, ids]);

  const setzen = async (s, ja) => {
    setSpeichert(s.wettkaempfer_id); setFehler('');
    try {
      const r = await fetch(`/api/fotos/${turnierId}/einwilligung`, {
        method: 'PUT', headers: { ...kopf(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ eintraege: [{ wettkaempfer_id: s.wettkaempfer_id, einwilligung: ja }] }),
      });
      const x = await r.json().catch(() => ({}));
      if (!r.ok || x.success === false) throw new Error(x.error || `HTTP ${r.status}`);
      setD((alt) => ({ ...alt, starter: alt.starter.map((y) => (y.wettkaempfer_id === s.wettkaempfer_id ? { ...y, einwilligung: ja, gesetzt: true } : y)) }));
    } catch (e) { setFehler(`Einwilligung nicht gespeichert: ${e.message}`); } finally { setSpeichert(null); }
  };

  if (!ids) return null;
  if (!d) return fehler ? <p className="fe-fehler">Foto-Einwilligung: {fehler}</p> : null;
  if (!d.starter.length) return null;
  const ja = d.starter.filter((s) => s.einwilligung).length;
  const kinder = d.starter.some((s) => s.minderjaehrig);

  return (
    <details className="fe-box">
      <summary>
        <strong>Fotos veröffentlichen?</strong>
        <span className="fe-stand">{ja} von {d.starter.length} eingewilligt</span>
        <span className="fe-aendern">ändern</span>
      </summary>
      <p className="fe-text">{d.text.selbst}</p>
      {kinder && <p className="fe-text"><strong>Minderjährige:</strong> {d.text.erziehungsberechtigte}</p>}
      <p className="fe-text fe-leise">Ohne Haken erscheint kein Foto mit dieser Person in der öffentlichen Galerie. Freiwillig, ohne Einfluss auf die Anmeldung.</p>
      <ul className="fe-liste">
        {d.starter.map((s) => (
          <li key={s.wettkaempfer_id}>
            <label className="fe-zeile">
              <input type="checkbox" checked={!!s.einwilligung} disabled={speichert === s.wettkaempfer_id}
                onChange={(e) => setzen(s, e.target.checked)} />
              <span className="fe-name">{s.vorname} {s.nachname}</span>
              <span className="fe-art">
                {s.minderjaehrig ? 'minderjährig: die Erziehungsberechtigten willigen ein, der Verein bestätigt das' : 'willigt ein'}
              </span>
            </label>
          </li>
        ))}
      </ul>
      {fehler && <p className="fe-fehler" role="alert">{fehler}</p>}
    </details>
  );
}
